import { post } from "mdui/api/HttpReq";

const fillBankCode = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    let val = formData['bank'];
    let newFormData = { ...formData, 'acctToBnkCd': val}
    updateState({ newFormData })
}

const fillGenBankCode = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    let val = formData[props.field.fldNm];
    if (props.field.callbackArgs) {
        let newFormData = { ...formData, [props.field.callbackArgs]: val}
        updateState({ newFormData })
    }
}

const fillBillOrgDet  = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    // let data = procModArgs(props.field, formData);
    let val = await post('md-mod-cfg', 'read', { cdtrId:formData?.uen, initOpr: 'edit', module: props.field.refModNm, action: 'edit', page: 0, perPage: 10 });
    console.log("valll",val)
    if (val.content) {
            let newFormData = { ...formData, "purpose":val?.content[0]?.billPurpose,"cdtrName":val?.content[0]?.cdtrName,"acctTo":val?.content[0]?.acctTo,"acctToBnkCd":val?.content[0]?.acctToBnkCd,"bnk":val?.content[0]?.bank }
            console.log("frmdata",newFormData)
            updateState({ newFormData })
    }
}

const classificationOnChange = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let hideFields = false;
    
    console.log('debitTypeOnChange config', config)

    if(formData.classification === 'D') {
        hideFields = true;
    }
    else {
        hideFields = false;
    }
    
    let attr = {
        glAccount: { hide: hideFields },
        cifNumber: { hide: hideFields },
    };

    let newFormData = {
        ...formData,
    }
    
    updateState({ newFormData, newAttr: attr })
}
 
export { fillBankCode, fillGenBankCode,fillBillOrgDet,classificationOnChange }